import styled from "styled-components";
import {Ellipsis} from "@FRAMEWORK/ui/desktop/text";

const Wrap = styled.div`
	width: 910px;
	margin: 60px auto;
`;

const LinkList = styled.ul`
	display: flex;
	flex-direction: column;
	width: 100%;
	margin-top: 20px;
	border: 1px solid var(--yellow-color);
`;

const LinkListItem = styled.li`
	font-size: var(--default-size);
	+ li {
		border-top: 1px solid var(--yellow-color);
	}
`;

const Link = styled.a`
	display: flex;
	justify-content: space-between;
	padding: 16px;
`;

const LinkTitle = styled.p`
	${Ellipsis(1)};
`;

const LinkArrow = styled.span`
	display: flex;
	align-items: center;
	white-space: nowrap;
	margin-left: 10px;
	border-bottom: 1px solid var(--default-color);
	&::after {
		display: inline-block;
		width: 7px;
		height: 7px;
		margin-top: 2px;
		margin-left: 5px;
		border-top: 1px solid var(--default-color);
		border-left: 1px solid var(--default-color);
		transform: rotate(135deg);
		content: "";
	}
`;

export {Link, LinkTitle, LinkArrow, LinkList, LinkListItem, Wrap};
